import { render, staticRenderFns } from "./ReservationStepper.vue?vue&type=template&id=5e84d884&scoped=true"
import script from "./ReservationStepper.vue?vue&type=script&lang=js"
export * from "./ReservationStepper.vue?vue&type=script&lang=js"
import style0 from "./ReservationStepper.vue?vue&type=style&index=0&id=5e84d884&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84d884",
  null
  
)

export default component.exports